import { differenceInDays, now } from 'owa-datetime';
import { getFirstOWAReactMiniLogon } from './getFirstOWAReactMiniLogon';

const DEFAULT_RETURN_VALUE = 1000;

export const getDaysSinceFirstMiniLogon = (): number => {
    const firstLogonDate = getFirstOWAReactMiniLogon();

    return firstLogonDate ? differenceInDays(now(), firstLogonDate) : DEFAULT_RETURN_VALUE;
};
